import page from 'page'
import { showCohortPage } from './cohorts/index.js'
import { showCommercePage } from './commerce/platforms/index.js'
import { showDemoComponent } from './demos/components/index.js'
import { showPageDemoFullHeight } from './demos/full-height-page/index.js'
import { showLayoutDemo } from './demos/layout/index.js'
import { showWebComponentsDemo } from './demos/web-components/index.js'

export function setupOtherFeaturesRoutes (baseRoute = '') {
  setupDemoRoutes(baseRoute)
  setupCommerceRoutes(baseRoute)
  setupCohortRoutes(baseRoute)
}

function setupDemoRoutes (baseRoute) {
  page(`${baseRoute}/demo`, function (context) {
    console.log('demo')
    showDemoComponent()
  })

  page(`${baseRoute}/demo/layout`, function (context) {
    showLayoutDemo()
  })

  page(`${baseRoute}/demo/web-components`, function (context) {
    showWebComponentsDemo()
  })

  page(`${baseRoute}/demo/layout-full-height`, function (context) {
    showPageDemoFullHeight()
  })
}

function setupCommerceRoutes (baseRoute = '') {
  page(`${baseRoute}/commerce`, function () {
    showCommercePage()
    removeLoadingAuth()
  })
}

export function setupCohortRoutes (baseRoute = '') {
  page(`${baseRoute}/cohorts`, function (context) {
    showCohortPage()
    removeLoadingAuth()
  })
}

function removeLoadingAuth () {
  document.querySelector('header-authenticated').remove()
}
